export const ACTIVITY_LOG_ATTRIBUTE = {
  STATUS: "status",
  REPORTER: "user",
  COMPANY_CONTACTS: "companyContacts",
  DESCRIPTION: "description",
  NAME: "name",
  QR_CODE: "isQRCodeEnabled",
  SERIAL_NUMBER: "serialNumber",
  IMAGE: "image",
  COMPONENTS: "component",
  ID: "id",
  FACILITY_ID: "facilityIdentifier",
  LINE_ID: "lineId",
  CUSTOMER_ADDRESS: "customerAddress",
  ARTICLE_NUMBER: "articleNumber",
  TITLE: "title",
  SCHEDULE: "schedule",
  PROCEDURE: "procedures",
  PARTS: "inventoryParts",
  FOLLOWERS: "followers",
  PREVENTIVE_MAINTENANCE: "preventiveMaintenance",
  MACHINES: "machine",
  MACHINE_HISTORY: "machineHistory",
  PRODUCTION_LINES: "productionLine",
  SECTION: "section",
  HEADING: "heading",
  FIELD: "field",
  ATTACHMENTS: "attachments",
  PROCEDURE_HEADER: "procedureHeader",
  ASSIGNEES: "assignees",
  TIME_TRACKING: "timeTrackerLogs",
  USER_ACCOUNT: "user",
  COMPONENT_ID: "componentId",
  TICKET: "ticket",
  CUSTOM_FIELD: "customField",
  TIME_TRACKING_CUSTOM_FIELD: "timeTrackingCustomField",
  RESOURCES: "resources",
  LINKED_TICKETS: "linkedTickets",
  // Work order <-> support ticket link rows (one attribute per side of the link).
  LINKED_SUPPORT_TICKET: "linkedSupportTicket",
  LINKED_WORK_ORDERS: "linkedWorkOrders",
  CONTACT: "contact",
  TYPE: "type",
  WEBSITE: "website",
  ASSET_TYPE: "assetType",
  HIERARCHY: "hierarchy",
  CUSTOMER: "customer",
  PARENT: "parent",
  STOCK: "stock",
  DUE_DATE: "dueDate",
  ARCHIVED: "archived",
  TEAM: "team",
  ASSETS: "assets",
  FACILITY: "facility",
  // Support-ticket-specific attributes (emitted by the support-ticket triggers).
  COMPANY: "company",
  SUPPORT_TICKET: "supportTicket",
};

export const ACTIVITY_LOG_ACTION = {
  CLOSED: "closed",
  REOPENED: "reopened",
  CHANGED: "changed",
  ASSIGNED: "assigned",
  UNASSIGNED: "unassigned",
  SCHEDULED: "scheduled",
  RESECHEDULED: "rescheduled",
  UNSECHEDULED: "unscheduled",
  ADDED: "added",
  REMOVED: "removed",
  ATTACHED: "attached",
  FILLED_ATTACHED: "filled_attached",
  FINALISED: "finalised",
  SAVED: "saved",
  UPDATED: "updated",
  ENABLED: "enabled",
  DISABLED: "disabled",
  GAVE: "gave",
  ALLOCATED: "allocated",
  LINKED: "linked",
  UNLINKED: "unlinked",
  // Emitted on the counterpart's feed when one resource is created from the other.
  WORK_ORDER_CREATED: "work_order_created",
  SUPPORT_TICKET_CREATED: "support_ticket_created",
  DETACHED: "detached",
  DELETED: "deleted",
  CREATED: "created",
  QUANTITY_CHANGED: "quantity_updated",
  // Support tickets only: the ticket's status was deleted from OEM settings and
  // the ticket was reassigned to another status. Actor-less (system) row.
  STATUS_DELETED: "status_deleted",
  SET: "set",
  CLEARED: "cleared",
};
